const initCapabilityProfiles = () => {
  const module = document.querySelector('.capability-profiles');

  if (!module) {
    return;
  }

  const regionButtons = module.querySelectorAll('.capability-profiles__region:not(.capability-profiles__region--disabled)');
  const continueButton = module.querySelector('.capability-profiles__continue-button');
  const selectionDisclaimer = module.querySelector('.capability-profiles__button-disclaimer');

  regionButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const region = button.getAttribute('data-id');
      const regionLink = button.getAttribute('data-href');

      regionButtons.forEach((btn) => btn.classList.remove('active'));

      button.classList.add('active');

      continueButton.style.display = 'flex';
      selectionDisclaimer.style.display = 'block';

      continueButton.classList.remove('disabled');

      continueButton.setAttribute('href', regionLink);
    });
  });
};

export default initCapabilityProfiles;